import TabTitle from './TabTitle';
import AdminOrganizationTabTitle from './AdminOrganizationTabTitle';

export { TabTitle, AdminOrganizationTabTitle };
